import { useLang } from "@/context/LanguageContext";

export default function WhatsAppButton({ config }) {
  const { t } = useLang();
  const number = (config?.whatsapp || "+31634973116").replace(/[^\d]/g, "");
  const href = `https://wa.me/${number}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label={t.whatsapp}
      className="fixed bottom-5 right-5 z-[60] flex items-center gap-2 h-14 pl-4 pr-5 rounded-full bg-whatsapp text-white shadow-lg hover:brightness-105 active:scale-95 transition-transform animate-pulsering group"
    >
      <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" className="shrink-0">
        <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm0 18.15c-1.53 0-3.03-.41-4.34-1.19l-.31-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 01-1.26-4.36c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 012.41 5.83c0 4.54-3.7 8.24-8.24 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29z" />
      </svg>
      <span className="text-sm font-semibold hidden sm:inline max-w-0 group-hover:max-w-[170px] overflow-hidden whitespace-nowrap transition-[max-width] duration-300">
        {t.whatsapp}
      </span>
    </a>
  );
}
